module.exports = "<!--Page Container-->\n<section class=\"main-container\">\n\n  <page-header></page-header>\n\n  <div class=\"container-fluid page-content\">\n\n    <app-transportes-viagens-table [id_transporte]=\"id_transporte\" *ngIf=\"!pageIsUpd && !pageIsAdd\"></app-transportes-viagens-table>\n\n  </div>\n\n  <page-footer></page-footer>\n\n</section>\n<!--/Page Container-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/transportes-viagens/transportes-viagens.component.html
// module id = ./src/app/transportes-viagens/transportes-viagens.component.html
// module chunks = main